export default __webpack_public_path__ + "static/media/user4.4cdce396.jpg";